import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x20800000 {
  commandID: number;
  mask: string;
}

export function Command0x20800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    commandID: 0,
    mask: "",
  };

  const [fields, setFields] = React.useState<Form0x20800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x20800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.commandID) {
      params.commandID = 0;
    }
    if (!params.mask) {
      params.mask = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          id="commandID"
          label="ID запроса"
          margin="dense"
          fullWidth
          value={fields.commandID}
          onChange={handleChangeField("commandID")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="mask"
          label="Маска имён файлов"
          margin="dense"
          fullWidth
          value={fields.mask}
          onChange={handleChangeField("mask")}
        />
      </FormControl>
    </>
  );
}
